import React from 'react';

import { Box, Grid, Typography } from '@mui/material';

import { DateFormatPatterns } from '@clearverify/constants';
import { Nullable } from '@clearverify/types';
import { formatDate } from '@clearverify/utils';

import { OverflowTooltip } from 'src/components/common';
import { DemoPrivacyText } from 'src/components/demoPrivacyMode';
import { SxProp } from 'src/types/mui';

type InboxItemCardHeader = {
  cardHeading: Nullable<string>;
  lastUpdatedAt: Nullable<string>;
  isUnreadStatus: boolean;
};

export const InboxItemCardHeader: React.FC<InboxItemCardHeader> = ({
  cardHeading,
  lastUpdatedAt,
  isUnreadStatus,
}) => {
  const renderUnreadStatusIcon = React.useCallback(() => {
    if (isUnreadStatus) {
      return <Box sx={newInboxItemStatusStyles} />;
    }

    return null;
  }, [isUnreadStatus]);

  return (
    <Grid container sx={cardHeaderWrapperStyles}>
      <Grid container alignItems="center" wrap="nowrap" size={8}>
        <OverflowTooltip variant="subtitle1">
          <DemoPrivacyText>{cardHeading}</DemoPrivacyText>
        </OverflowTooltip>
        {renderUnreadStatusIcon()}
      </Grid>
      <Grid textAlign="right">
        <Typography variant="body3">
          {formatDate(lastUpdatedAt, DateFormatPatterns.shortDateWithSlash)}
        </Typography>
      </Grid>
    </Grid>
  );
};

const cardHeaderWrapperStyles: SxProp = {
  alignItems: 'center',
  justifyContent: 'space-between',
};

const newInboxItemStatusStyles: SxProp = {
  minHeight: '8px',
  minWidth: '8px',
  backgroundColor: '#1565C0',
  borderRadius: '50%',
  display: 'inline-block',
  marginLeft: '8px',
  marginBottom: '1px',
};
